var map = {
	"./css/codeExample.txt": "./src/parsers/css/codeExample.txt",
	"./css/cssom.js": "./src/parsers/css/cssom.js",
	"./css/index.js": "./src/parsers/css/index.js",
	"./css/postcss.js": "./src/parsers/css/postcss.js",
	"./css/rework.js": "./src/parsers/css/rework.js",
	"./css/transformers/postcss/codeExample.txt": "./src/parsers/css/transformers/postcss/codeExample.txt",
	"./css/transformers/postcss/index.js": "./src/parsers/css/transformers/postcss/index.js",
	"./graphql/codeExample.txt": "./src/parsers/graphql/codeExample.txt",
	"./graphql/graphql-js.js": "./src/parsers/graphql/graphql-js.js",
	"./graphql/index.js": "./src/parsers/graphql/index.js",
	"./html/codeExample.txt": "./src/parsers/html/codeExample.txt",
	"./html/htmlparser2.js": "./src/parsers/html/htmlparser2.js",
	"./html/index.js": "./src/parsers/html/index.js",
	"./html/parse5.js": "./src/parsers/html/parse5.js",
	"./js/acorn.js": "./src/parsers/js/acorn.js",
	"./js/babel-eslint.js": "./src/parsers/js/babel-eslint.js",
	"./js/babylon.js": "./src/parsers/js/babylon.js",
	"./js/babylon6.js": "./src/parsers/js/babylon6.js",
	"./js/codeExample.txt": "./src/parsers/js/codeExample.txt",
	"./js/espree.js": "./src/parsers/js/espree.js",
	"./js/esprima.js": "./src/parsers/js/esprima.js",
	"./js/flow.js": "./src/parsers/js/flow.js",
	"./js/index.js": "./src/parsers/js/index.js",
	"./js/recast.js": "./src/parsers/js/recast.js",
	"./js/shift.js": "./src/parsers/js/shift.js",
	"./js/traceur.js": "./src/parsers/js/traceur.js",
	"./js/transformers/babel/codeExample.txt": "./src/parsers/js/transformers/babel/codeExample.txt",
	"./js/transformers/babel/index.js": "./src/parsers/js/transformers/babel/index.js",
	"./js/transformers/babel6/codeExample.txt": "./src/parsers/js/transformers/babel6/codeExample.txt",
	"./js/transformers/babel6/index.js": "./src/parsers/js/transformers/babel6/index.js",
	"./js/transformers/eslint/codeExample.txt": "./src/parsers/js/transformers/eslint/codeExample.txt",
	"./js/transformers/eslint/index.js": "./src/parsers/js/transformers/eslint/index.js",
	"./js/transformers/eslint/loadRulesShim.js": "./src/parsers/js/transformers/eslint/loadRulesShim.js",
	"./js/transformers/jscodeshift/codeExample.txt": "./src/parsers/js/transformers/jscodeshift/codeExample.txt",
	"./js/transformers/jscodeshift/index.js": "./src/parsers/js/transformers/jscodeshift/index.js",
	"./js/typescript.js": "./src/parsers/js/typescript.js",
	"./js/uglify.js": "./src/parsers/js/uglify.js",
	"./webidl/codeExample.txt": "./src/parsers/webidl/codeExample.txt",
	"./webidl/index.js": "./src/parsers/webidl/index.js",
	"./webidl/webidl2.js": "./src/parsers/webidl/webidl2.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;



/*****************
 ** WEBPACK FOOTER
 ** ./src/parsers ^\.\/(?!utils)[^\/]+\/(transformers\/([^\/]+)\/)?(codeExample\.txt|[^\/]+?\.js)$
 ** module id = 1
 ** module chunks = 0
 **/